import { useState, useMemo, useRef } from "react"
import { useRequest } from "ahooks";
import { Card, Button, Table as antdTable } from "antd";
import { Table, DEFAULT_PAGE_DATA } from "../../../components/table";
import { generateTableColumns, DEFAULT_QUERY_DATA, generateQueryFormConfig } from "./config";
import { AmountServer } from "../../../server";
import { EditForm } from "../../../components/editForm";
import dayjs from "dayjs";

const server = AmountServer.BalanceLog

export const BalanceLog = () => {
    const operationRef: any = useRef();

    const [queryData, setQueryData] = useState<any>({ ...DEFAULT_QUERY_DATA });
    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);
    const [summaryData, setSummaryData] = useState<any>({});
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });
    const [options, setOptions] = useState<any>({
        scenceOptions: [],
        statusOptions: [],
        trackOptions: [],
    })

    //获取表格数据
    const { run, refresh } = useRequest(server.list, {
        defaultParams: [{ ...pageData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setSummaryData({});
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize, Summary } = res;
            setSummaryData(Summary);
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });

    useRequest(() => Promise.all([
        server.scene({}),
        server.status({}),
        server.track({}),
    ]), {
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setOptions({
                scenceOptions: [],
                statusOptions: [],
                trackOptions: [],
            })
        },
        onSuccess: (res: any) => {
            setOptions({
                scenceOptions: Object.keys(res[0])?.map((e: any) => ({ id: e, name: res[0][e] })),
                statusOptions: Object.keys(res[1])?.map((e: any) => ({ id: e, name: res[1][e] })),
                trackOptions: Object.keys(res[2])?.map((e: any) => ({ id: e, name: res[2][e] })),
            })
        }
    });

    const { run: exportLog } = useRequest(server.export, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onSuccess: (res: any) => {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `余额日志_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`; // 设置下载文件的名称
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    });

    const getQueryFormConfig = useMemo(() => {
        return generateQueryFormConfig({ options });
    }, [options]);

    const getTableColumns = useMemo(() => {
        return generateTableColumns({ operationRef, loading, setLoading, refresh });
    }, [operationRef, loading, setLoading, refresh]);

    const formatQueryDate = () => {
        let { Daily, DateStart, DateEnd, Date, ...otherData } = queryData;
        DateStart = DateStart ? DateStart.split('-').join('') : '';
        DateEnd = DateEnd ? DateEnd.split('-').join('') : '';
        return { ...otherData, DateStart, DateEnd };
    };

    return (
        <div>
            <Card>
                <div className="flex flex-between">
                    <EditForm
                        componentId="banlanceLog-query-form"
                        loading={loading}
                        formAttrsProps={{
                            layout: 'inline',
                        }}
                        formData={queryData}
                        onDataChange={setQueryData}
                        formConfig={getQueryFormConfig}
                        onQuery={() => {
                            run({ ...DEFAULT_PAGE_DATA, ...formatQueryDate() });
                        }}
                        onReset={() => {
                            setQueryData({ ...DEFAULT_QUERY_DATA });
                            run({ ...DEFAULT_QUERY_DATA, ...DEFAULT_PAGE_DATA });
                        }}
                    />
                    <Button className="ml10" type="primary" onClick={() => exportLog({ ...formatQueryDate() })}>导出</Button>
                </div>
            </Card>

            <Card className="mt20">
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content',
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage, ...formatQueryDate() });
                    }}
                    summary={() => (
                        <antdTable.Summary fixed>
                            <antdTable.Summary.Row>
                                <antdTable.Summary.Cell index={0}><span style={{ color: "red" }}>总计：</span></antdTable.Summary.Cell>
                                <antdTable.Summary.Cell index={1}></antdTable.Summary.Cell>
                                <antdTable.Summary.Cell index={2}><span style={{ color: "red" }}>变动金额： {summaryData?.totalAmount || ''}</span> </antdTable.Summary.Cell>
                            </antdTable.Summary.Row>
                        </antdTable.Summary>
                    )}
                />
            </Card >
        </div>
    );
}